<template><section><h1>Toast</h1>
<blockquote>
<p>提示</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<pre><code class="language-js"><span class="hljs-keyword">let</span> vm = <span class="hljs-keyword">this</span>.$toast(content, type)
<span class="hljs-keyword">let</span> vm = <span class="hljs-keyword">this</span>.$toast(content, options)
</code></pre>
<h2>Options</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>content</td>
<td style="text-align:left">提示文本</td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>type</td>
<td style="text-align:left">主题，可选值<code>default/primary/success/warning/error</code></td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>time</td>
<td style="text-align:left">自动关闭的延时，单位毫秒（为<code>0</code>时则不自动消失）</td>
<td><code>Number</code></td>
<td><code>2000</code></td>
</tr>
<tr>
<td>callback</td>
<td style="text-align:left">消失后回调</td>
<td><code>Function</code></td>
<td>-</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Toast.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-26.vue?6b5d1238